import React from "react";
import {
    WAVE_HEIGHT,
    WAVE_OFFSET_X_LEFT,
    WAVE_OFFSET_Y,
    WAVE_SVG_HEIGHT,
    WAVE_VIEWBOX
} from "../utils/svg";
import {WaveFunction} from "../waveforms";

interface WaveProps {
    f: WaveFunction,
    phase: number       // phase at 0, in [deg]
    offset: number,     // 0..1
    amplitude: number   // 0..1
}

export const Wave = ({f, phase, offset, amplitude}: WaveProps) => {

    // SVG Y axis has 0 on top

    // console.log("Wave");

    // const dots = React.useMemo(
    //     () => {
    //         const d: number[] = [];
    //         // console.log("recompute dots");
    //         for(let x=0; x<360; x++) {
    //             let y = Math.min(Math.max(((amplitude / 2) * f(x + phase) + offset) * WAVE_HEIGHT, 0), WAVE_HEIGHT)
    //             d.push(WAVE_SVG_HEIGHT - (WAVE_OFFSET_Y + y));
    //         }
    //         return d;
    //     },
    //     [f, phase, offset, amplitude]
    // );

    // It seems to be faster without memoization:

    const dots: number[] = [];
    for(let x=0; x<360; x++) {
        let y = Math.min(Math.max(((amplitude / 2) * f(x + phase) + offset) * WAVE_HEIGHT, 0), WAVE_HEIGHT);
        dots.push(WAVE_SVG_HEIGHT - (WAVE_OFFSET_Y + y));
    }

    // console.log("Wave", f(1), Math.min(Math.max(((amplitude / 2) * f(1) + offset) * WAVE_HEIGHT, 0), WAVE_HEIGHT));

    return (
        <svg viewBox={WAVE_VIEWBOX}>
            {dots.map((y, x) =>
                {
                    // console.log(x, y, dots[x-1], Math.abs(dots[x-1] - y));
                    if ((x > 0) && (Math.abs(dots[x-1] - y) > 2)) {
                        // console.log("waveline", x, y, dots[x-1], Math.abs(dots[x-1] - y));
                        return <line key={x} x1={x + WAVE_OFFSET_X_LEFT} y1={dots[x-1]}
                                             x2={x + WAVE_OFFSET_X_LEFT} y2={y} stroke="#000" />
                    } else {
                        return <circle key={x} cx={x + WAVE_OFFSET_X_LEFT} cy={y} r="1" />
                    }
                }
            )}
        </svg>
    );

};
